import { openDB } from 'idb';

const DB_NAME = 'TS-WAY';
const DB_VERSION = 1.1;
const STORE_NAMES = ['reports'];

export const initDB = async () => {
  return await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      STORE_NAMES.forEach((name) =>{
        if (!db.objectStoreNames.contains(name)) {
          db.createObjectStore(name, {
            keyPath: 'id',
            autoIncrement: true,
          });
        }
      })
    },
  });
};

export const addData = async (data, STORE_NAME) => {
  const db = await initDB(STORE_NAME);
  if (db){
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await store.put({ data: data });
    await tx.done;
  }
};

export const getData = async (STORE_NAME) => {
  const db = await initDB(STORE_NAME);
  if(STORE_NAME){
    return db.getAll(STORE_NAME);
  }
};

export const clearData = async (STORE_NAME) => {
  const db = await initDB(STORE_NAME);
  if (STORE_NAME) {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await store.clear();
    await tx.done;
  }
};

export const deleteData = async (key, STORE_NAME) => {
  const db = await initDB(STORE_NAME);
  if (STORE_NAME) {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);
    await store.delete(key);
  }
};
